import { render } from "./selectcity.vue?vue&type=template&id=6d5f1380"
import script from "./selectcity.vue?vue&type=script&lang=js"
export * from "./selectcity.vue?vue&type=script&lang=js"

import exportComponent from "/var/jenkins_home/workspace/edu-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__